import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {AppTheme} from './app.theme';
import {OAuthModule, provideOAuthClient} from "angular-oauth2-oidc";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {ConfirmationService, MessageService} from "primeng/api";
import {authInterceptor} from "@core/interceptors/auth-interceptor";
import localePt from '@angular/common/locales/pt';
import {registerLocaleData} from "@angular/common";

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // eventCoalescing:true fazia cliques nos overlays do PrimeNG (p-select com
    // appendTo="body") não dispararem change detection: o valor mudava no
    // FormControl (salvava certo) mas o <p-select> não atualizava na tela.
    provideZoneChangeDetection({eventCoalescing: false}),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    importProvidersFrom(
      OAuthModule.forRoot()
    ),
    MessageService,
    ConfirmationService,
    provideOAuthClient(),
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: '.dark'
        }
      },
      translation: {
        // Filtros
        startsWith: 'Começa com',
        contains: 'Contém',
        notContains: 'Não contém',
        endsWith: 'Termina com',
        equals: 'Igual a',
        notEquals: 'Diferente de',
        noFilter: 'Sem filtro',
        lt: 'Menor que',
        lte: 'Menor ou igual a',
        gt: 'Maior que',
        gte: 'Maior ou igual a',
        dateIs: 'É igual a',
        dateIsNot: 'Não é igual a',
        dateBefore: 'Antes de',
        dateAfter: 'Depois de',

        // Botões e ações
        clear: 'Limpar',
        apply: 'Aplicar',
        matchAll: 'Combinar todos',
        matchAny: 'Combinar qualquer',
        addRule: 'Adicionar regra',
        removeRule: 'Remover regra',
        accept: 'Sim',
        reject: 'Não',
        choose: 'Selecionar',
        upload: 'Enviar',
        cancel: 'Cancelar',
        completed: 'Concluído',
        pending: 'Pendente',

        // Tamanhos de arquivo
        fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],

        // Calendário
        dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: [
          'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
          'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
        ],
        monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        chooseYear: 'Selecionar ano',
        chooseMonth: 'Selecionar mês',
        chooseDate: 'Selecionar data',
        prevDecade: 'Década anterior',
        nextDecade: 'Próxima década',
        prevYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        prevMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        prevHour: 'Hora anterior',
        nextHour: 'Próxima hora',
        prevMinute: 'Minuto anterior',
        nextMinute: 'Próximo minuto',
        prevSecond: 'Segundo anterior',
        nextSecond: 'Próximo segundo',

        // DataTable
        emptyMessage: 'Nenhum registro encontrado',
        emptyFilterMessage: 'Nenhum registro corresponde ao filtro aplicado',
        emptySearchMessage: 'Nenhum registro encontrado',
        emptySelectionMessage: 'Nenhum registro encontrado',

        selectionMessage: '{0} opções selecionadas',
      }
    }),
  ]
};
